<template>
  <div class="menu">
    <LanguageSelect :lang="lang" />
    <ul>
      <li
        @click="
          isSplashOpenAction();
          isMenuOpenAction();
        "
      >
        Home <i class="fas fa-home"></i>
      </li>
      <li v-for="(item, index) in resources[getLanguage]" :key="index">
        <a :href="item.link" target="_blank">
          {{ item.resource }} <i class="fas fa-external-link-alt"></i>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LanguageSelect from "./LanguageSelect.vue";

export default {
  components: { LanguageSelect },
  props: {
    resources: {
      type: Object,
      default: null,
    },
    lang: {
      type: String,
      default: null,
    },
  },

  computed: {
    ...mapGetters(["getIsSplashOpen", "getLanguage"]),
  },
  methods: {
    ...mapActions(["isSplashOpenAction", "isMenuOpenAction", "languageAction"]),
  },
};
</script>

<style>
</style>